import {Collection} from 'ol';
import {fromLonLat, toLonLat} from 'ol/proj';
import {closeModal, url} from "../utilities";
import Spinner from "../spinner";
import {fillFormInputs, handleApiForm, hideField, renderList, showField} from "../forms";
import {toastAlert} from "../toastAlert";
import axios from "axios";
import {confirmModal} from "../confirmModal";
import {in_app} from "../app";
import {drawSectorsStyle} from "../map/styles/sectors";
import {EpMap} from "../map/map";
import {createFeatureFromCoordinates} from "../map/utilities";
import Point from "ol/geom/Point";
import {
    zonesStyle,
    drawZonesStyle,
} from "../map/styles/zones";
import * as $ from "jquery";
import {handleShpForm} from "../shp";

export const districts_map = () => {

    let body = $("body");
    let mapContainer = $("#mapContainer");

    // TABLES
    let sectorsTable = $("#sectorsTable");
    let devicesTable = $("#devicesTable");
    let zonesTable = $("#zonesTable");

    let isInApp = $("button[data-bs-target=\"#addSectorModal\"]").data('in_app') ?? null;

    const sectorsTableApi = sectorsTable.DataTable({
        stateSave: false,
        order: [isInApp ? 0 : 1, 'asc'],
        'columnDefs': [
            {
                'targets': isInApp ? 0 : 1,
                'type': 'natural'
            },
        ]
    }).api();

    const devicesTableApi = devicesTable.DataTable({
        stateSave: false,
        order: [[isInApp ? 3 : 4, 'asc'], [isInApp ? 0 : 1, 'asc']],
        'columnDefs': [
            {
                'targets': isInApp ? 0 : 1,
                'type': 'natural'
            },
            {
                'targets': isInApp ? 3 : 4,
                'visible': false,
                'searchable': false,
            }
        ]
    }).api();

    const zonesTableApi = zonesTable.DataTable({
        stateSave: false,
        order: [isInApp ? 0 : 1, 'asc'],
        'columnDefs': [
            {
                'targets': isInApp ? 0 : 1,
                'type': 'natural'
            },]
    }).api();

    const SECTOR_ENABLED_INDEX = isInApp ? 1 : 2;
    const SECTOR_ACTIVE_INDEX = isInApp ? 2 : 3;
    const SECTOR_ACTION_INDEX = isInApp ? 3 : 4;
    const ZONE_ACTION_INDEX = isInApp ? 3 : 4;


    if (sectorsTable.length > 0) {
        sectorsTable.on('check-all.changed', function (e, any) {
            $("#btnGroupDeleteSectors").attr('disabled', !any);
        })
    }

    if (devicesTable.length > 0) {
        devicesTable.on('check-all.changed', function (e, any) {
            $("#btnGroupDeleteDevices").attr('disabled', !any);
        })
    }

    if (zonesTable.length > 0) {
        zonesTable.on('check-all.changed', function (e, any) {
            $("#btnGroupDeleteZones").attr('disabled', !any);
        })
    }

    // grupowe usuwanie sektorów
    handleApiForm("#deleteSelectedSectors", ({response}) => {
        if (response.data.code === 200) {
            window.location.reload();
        }
    }, (form) => {
        return new Promise(async (resolve, reject) => {
            let confirm = await confirmModal('Czy na pewno chcesz usunąć wybrane sektory?', {color: 'danger'})

            if (confirm) {
                let inputs = sectorsTable.DataTable().$('input[type="checkbox"]');
                for (let input of inputs) {
                    if ($(input).prop('checked')) {
                        form.append(`<input type="hidden" name="id[]" value="${$(input).val()}" />`);
                    }
                }

                resolve()
            } else {
                reject()
            }
        })
    })

    // grupowe usuwanie urządzeń
    handleApiForm("#deleteSelectedDevices", ({response}) => {
        if (response.data.code === 200) {
            window.location.reload();
        }
    }, (form) => {
        return new Promise(async (resolve, reject) => {
            let confirm = await confirmModal('Czy na pewno chcesz usunąć wybrane urządzenia?', {color: 'danger'})

            if (confirm) {
                let inputs = devicesTable.DataTable().$('input[type="checkbox"]');
                for (let input of inputs) {
                    if ($(input).prop('checked')) {
                        form.append(`<input type="hidden" name="id[]" value="${$(input).val()}" />`);
                    }
                }

                resolve()
            } else {
                reject()
            }
        })
    })

    // grupowe usuwanie ograniczeń
    handleApiForm("#deleteSelectedZones", ({response}) => {
        if (response.data.code === 200) {
            window.location.reload();
        }
    }, (form) => {
        return new Promise(async (resolve, reject) => {
            let confirm = await confirmModal('Czy na pewno chcesz usunąć wybrane ograniczenia?', {color: 'danger'})

            if (confirm) {
                let inputs = zonesTable.DataTable().$('input[type="checkbox"]');
                for (let input of inputs) {
                    if ($(input).prop('checked')) {
                        form.append(`<input type="hidden" name="id[]" value="${$(input).val()}" />`);
                    }
                }

                resolve()
            } else {
                reject()
            }
        })
    })


    if (mapContainer.length === 0) {
        return;
    }

    const changeMapSize = () => {
        let contentHeight = $("section.content").innerHeight();
        let breadcrumbsHeight = $(".breadcrumb").height();
        let tabsHeight = $(".nav.nav-tabs").height();

        mapContainer.height(contentHeight - breadcrumbsHeight - tabsHeight - 128);
    }
    changeMapSize();

    $(window).on('resize', () => {
        changeMapSize();
    })

    $("#map-tab").click(function () {
        setTimeout(() => {
            map.updateSize();
            view.fit(sectorsSource.getExtent(), {padding: [24, 24, 24, 24]})
        }, 500);
    })

    handleApiForm("#addSector", function ({response}) {
        let modalInstance = bootstrap.Modal.getInstance(document.getElementById("addSectorModal"));
        modalInstance.hide();

        let sector = response.data.sector;
        let row = $(`<tr data-id="${sector.id}"/>"`);
        if (!isInApp) {
            row.append(`<td>
                <input
                    data-readonly="true"
                    type="checkbox"
                    class="form-check-input input__sectors"
                    value="${sector.id}"
                />
            </td>`)
        }
        row.append(`<td class="sector__name">${sector.name}</td>`);
        row.append(`<td class="sector__is_enabled">${parseInt(sector.is_enabled) === 1 ? 'Tak' : 'Nie'}</td>`);
        row.append(`<td>Tak</td>`);
        row.append(`
            <td>
                <div class="btn-group flex-wrap">
                    <button class="btnEditSector btn btn-sm btn-primary" title="Edytuj dane">
                        <i class="fas fa-edit"></i>
                    </button>
                    <button class="btnEditCoordinates btn btn-sm btn-primary" title="Edytuj geometrię">
                        <i class="fas fa-map-marker-alt"></i>
                    </button>
                    <button
                            type="submit"
                            class="btnChangeSectorState btn btn-sm ${parseInt(sector.is_enabled) === 1 ? 'btn-danger' : 'btn-primary'}"
                            title="${parseInt(sector.is_enabled) === 1 ? 'Wyłącz' : 'Włącz'}">
                        <i class="fas fa-power-off"></i>
                    </button>
                    <button class="btnSectorShutdowns btn btn-sm btn-secondary" title="Zamknięcia">
                        <i class="fas fa-lock"></i>
                    </button>
                </div>
            </td>
        `);

        sectorsTableApi.rows.add(row).draw();
        toastAlert('Pomyślnie dodano nowe miejsce polowania');
    })

    handleApiForm("#editSector", function ({response}) {
        let modalInstance = bootstrap.Modal.getInstance(document.getElementById("editSectorModal"));
        modalInstance.hide();

        let sector = response.data.sector;
        let row = sectorsTable.DataTable().$(`tr[data-id="${sector.id}"]`);
        row.find('.sector__name').text(sector.name);

        let feature = sectorsSource.getFeatureById(sector.id);
        if (feature) {
            feature.set('name', sector.name);
        }

        toastAlert('Pomyślnie edytowano miejsce polowania');
    })

    let addZoneKindSelect = $("#addZone_zone_kind_id");
    let addZoneTypeSelect = $("#addZone_zone_type_id");
    let addZoneShutdownReason = $(".shutdown__reason");

    addZoneShutdownReason.hide();

    addZoneKindSelect.on('change', async function (e) {
        e.preventDefault();
        let id = $(this).children("option:selected").val();
        addZoneShutdownReason.hide();
        try {
            let response = await axios.get(url(`api/zones/types?type_id=${id}`));

            $(this).children("option[value='0']").remove();
            addZoneTypeSelect.empty();
            let data = response.data;

            for (let type of data.types) {
                addZoneTypeSelect.append(`<option value=${type.id}>${type.name}</option>`);
            }

        } catch (err) {
            console.log(err);
            toastAlert('Wystąpił błąd podczas dodawania strefy', {type: 'danger'})
        }

    })

    addZoneTypeSelect.on('change', function () {
        if (parseInt($(this).children("option:selected").val()) === 7) {
            addZoneShutdownReason.show();
        } else {
            addZoneShutdownReason.hide();
        }

    })

    let editZoneKindSelect = $("#editZone_zone_kind_id");
    let editZoneTypeSelect = $("#editZone_zone_type_id");
    let editZoneShutdownReason = $(".shutdown__reason_edit");

    editZoneShutdownReason.hide();

    editZoneTypeSelect.on('change', function () {
        if (parseInt($(this).children("option:selected").val()) === 7) {
            editZoneShutdownReason.show();
        } else {
            editZoneShutdownReason.hide();
        }
    })

    editZoneKindSelect.on('change', async function (e) {
        e.preventDefault();
        let id = $(this).children("option:selected").val();
        editZoneShutdownReason.hide();
        try {
            let response = await axios.get(url(`api/zones/types?type_id=${id}`));

            $(this).children("option[value='0']").remove();
            editZoneTypeSelect.empty();
            let data = response.data;

            for (let type of data.types) {
                editZoneTypeSelect.append(`<option value=${type.id}>${type.name}</option>`);
            }

        } catch (err) {
            console.log(err);
            toastAlert('Wystąpił błąd podczas edycji strefy', {type: 'danger'})
        }

    })


    handleApiForm("#addZone", function ({response}) {
        let modalInstance = bootstrap.Modal.getInstance(document.getElementById("addZoneModal"));
        modalInstance.hide();

        let zone = response.data.zone;
        let row = $(`<tr data-id="${zone.id}"/>`);
        let icon = (` <i class="fas fa-info-circle text-primary dataTip" data-bs-toggle="tooltip" data-bs-placement="top" title="${zone.shutdown_reason}"></i>`);
        if (!isInApp) {
            row.append(`<td>
                <input
                    data-readonly="true"
                    type="checkbox"
                    class="form-check-input input__zones"
                    value="${zone.id}"
                />
            </td>`)
        }
        row.append(`<td class="zone__name">${zone.name}</td>`);
        row.append(`<td class="zone__kind">${zone.kind.name}</td>`);
        row.append(`<td class="zone__type" data-type='${zone.type.id}'>${zone.type.name}</td>`);
        if (parseInt(zone.type.id) === 7) {
            row.find('.zone__type').append(icon);
        }
        row.append(`
            <td>
                <div class="btn-group">
                    <button class="btnEditZone btn btn-sm btn-primary" title="Edytuj dane">
                        <i class="fas fa-edit"></i>
                    </button>
                    <button class="btnEditZoneCoordinates btn btn-sm btn-primary"
                            title="Edytuj geometrię">
                        <i class="fas fa-map-marker-alt"></i>
                    </button>
                    <button
                            type="submit"
                            class="btnDeleteZone btn btn-sm btn-danger"
                            title="Usuń">
                        <i class="fas fa-trash"></i>
                    </button>
                </div>
            </td>
        `);

        zonesTableApi.rows.add(row).draw();
        zonesTable.$('.dataTip').each(function () {
            new bootstrap.Tooltip(this)
        });
        toastAlert('Pomyślnie dodano nową strefę!');
    })

    body.on("click", ".btnEditZone", async function (e) {
        e.preventDefault();

        let row = $(this).closest('tr');
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }

        let modalDOM = document.getElementById("editZoneModal");
        let id = row.data('id');
        let form = $("#editZone");
        form.attr('action', url(in_app() ? `api/zones/${id}/edit` : `api/admin/zones/${id}/edit`));

        let modalInstance = bootstrap.Modal.getInstance(modalDOM);
        if (!modalInstance) {
            modalInstance = new bootstrap.Modal(modalDOM);
        }
        modalInstance.show();

        let spinner = new Spinner();
        try {
            let response = await axios.get(url(in_app() ? `api/zones/${id}` : `api/admin/zones/${id}`));
            spinner.destroy();

            if (response.data.status === 200) {
                let zone = response.data.zone;
                let types = response.data.types;
                editZoneTypeSelect.empty();
                for (let type of types) {
                    editZoneTypeSelect.append(`<option value=${type.id}>${type.name}</option>`);
                }
                if (parseInt(zone.zone_type_id) === 7) {
                    $('.shutdown__reason_edit').show();
                } else {
                    $('.shutdown__reason_edit').hide();

                }
                fillFormInputs(form, zone);
            }
        } catch (err) {
            toastAlert('Wystąpił błąd podczas edycji strefy!', {type: 'danger'})
        }
    })


    handleApiForm("#editZone", function ({response}) {
        let modalInstance = bootstrap.Modal.getInstance(document.getElementById("editZoneModal"));
        modalInstance.hide();

        let zone = response.data.zone;
        let row = zonesTable.DataTable().$(`tr[data-id="${zone.id}"]`);
        row.find('.zone__name').text(zone.name);
        row.find('.zone__kind').text(zone.kind.name);
        let zone_type_col = row.find('.zone__type');
        zone_type_col.attr('data-type', zone.type.id);
        let icon = (` <i class="fas fa-info-circle text-primary dataTip" data-bs-toggle="tooltip" data-bs-placement="top" title='${zone.shutdown_reason}'></i>`);
        zone_type_col.text(zone.type.name);

        if (parseInt(zone.type.id) === 7) {
            zone_type_col.append(icon);
        }

        let feature = zonesSource.getFeatureById(zone.id);
        if (feature) {
            feature.set('name', zone.name);
            feature.set('type', zone.type.id);
            feature.setStyle(zonesStyle);
        }

        zonesTableApi.draw();
        zonesTable.$('.dataTip').each(function () {
            new bootstrap.Tooltip(this)
        });

        toastAlert('Pomyślnie edytowano strefę');
    })

    body.on("click", ".btnDeleteZone", async function (e) {
        e.preventDefault();

        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć tę strefę?', {color: 'danger'});
        if (!confirm) {
            return;
        }

        let row = $(this).closest('tr');
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }

        let id = row.data('id');
        let spinner = new Spinner();

        try {
            let response = await axios.post(url(in_app() ? `api/zones/${id}/delete` : `api/admin/zones/${id}/delete`));
            spinner.destroy();

            if (response.data.status === 200) {
                zonesTableApi.rows(row).remove().draw();

                let feature = zonesSource.getFeatureById(id);
                zonesSource.removeFeature(feature);

                toastAlert('Pomyślnie usunięto strefę');
            }
        } catch (err) {
        }
    })

    handleApiForm("#addDevice", function ({response}) {
        let modalInstance = bootstrap.Modal.getInstance(document.getElementById("addDeviceModal"));
        modalInstance.hide();

        let device = response.data.device;
        let row;
        if (device.longitude && device.latitude) {
            row = $(`<tr data-id="${device.id}"/>`);
        } else {
            row = $(`<tr data-id="${device.id}" class="deviceNoCoords"/>`);
        }

        if (!isInApp) {
            row.append(`<td>
                <input
                    data-readonly="true"
                    type="checkbox"
                    class="form-check-input input__devices"
                    value="${device.id}"
                />
            </td>`)
        }
        row.append(`<td class="device__name">${device.name}</td>`);
        row.append(`<td class="device__type" data-id="${device.type.id}">${device.type.name}</td>`);
        row.append(`
            <td>
                <div class="btn-group flex-wrap">
                    <button class="btnEditDevice btn btn-sm btn-primary" title="Edytuj dane">
                        <i class="fas fa-edit"></i>
                    </button>
                    <button class="btnEditDeviceCoordinates btn btn-sm btn-primary" title="Edytuj geometrię">
                        <i class="fas fa-map-marker-alt"></i>
                    </button>
                    <button
                            type="submit"
                            class="btnDeleteDevice btn btn-sm btn-danger"
                            title="Usuń">
                        <i class="fas fa-trash"></i>
                    </button>
                </div>
            </td>
        `);
        if (device.longitude && device.latitude) {
            row.append(`<td>1</td>`)

        } else {
            row.append(`<td>0</td>`)
        }

        if (device.latitude && device.longitude) {

            let coordinates = device.longitude + ',' + device.latitude;

            epMap.devices.addToMapFromCoordinates(coordinates, {
                id: device.id,
                name: device.name,
                device_type_id: device.device_type_id,
            });
        }


        devicesTable.DataTable().api().rows.add(row).draw();
        toastAlert('Pomyślnie dodano nowe urządzenie');
    })

    handleApiForm("#editDevice", function ({response}) {
        let modalInstance = bootstrap.Modal.getInstance(document.getElementById("editDeviceModal"));
        modalInstance.hide();

        let device = response.data.device;
        let row = devicesTable.DataTable().$(`tr[data-id="${device.id}"]`);
        row.find('.device__name').text(device.name);
        row.find('.device__type').text(device.type.name);

        // let feature = devicesSource.getFeatureById(device.id);
        // if (feature) {
        //     feature.set('name', device.name);
        // }
        if (device.latitude && device.longitude) {
            row.removeClass('deviceNoCoords');
            row.find('device__has_coordinates').text(1);
            let feature = devicesSource.getFeatureById('device-' + device.id);
            if (!feature) {
                let coordinates = device.longitude + ',' + device.latitude;

                epMap.devices.addToMapFromCoordinates(coordinates, {
                    id: device.id,
                    name: device.name,
                    device_type_id: device.device_type_id,
                });

            } else {
                feature.getGeometry().setCoordinates(fromLonLat([device.longitude, device.latitude]));
            }
        }
        toastAlert('Pomyślnie edytowano urządzenie');
    })

    body.on("click", ".btnChangeSectorState", async function (e) {
        e.preventDefault();

        let row = $(this).closest('tr');
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }

        let id = row.data('id');
        let spinner = new Spinner();

        try {

            let response = await axios.post(url(in_app() ? `api/sectors/${id}/change-state` : `api/admin/sectors/${id}/change-state`));

            spinner.destroy();

            if (response.data.status === 200) {
                let rowIndex = sectorsTableApi.row(row).index();
                let cell = sectorsTableApi.cell(rowIndex, SECTOR_ENABLED_INDEX);

                let actionCell = sectorsTableApi.cell(rowIndex, SECTOR_ACTION_INDEX).node();
                $(actionCell).find('.btnChangeSectorState').toggleClass('btn-primary');
                $(actionCell).find('.btnChangeSectorState').toggleClass('btn-danger');

                if (actionCell) {
                    sectorsTableApi.cell(rowIndex, SECTOR_ACTION_INDEX).data(actionCell[0]);
                    sectorsTableApi.rows().invalidate();
                }

                row.next('tr.child').find('.btnChangeSectorState').toggleClass('btn-primary');
                row.next('tr.child').find('.btnChangeSectorState').toggleClass('btn-danger');

                if (response.data.state === 0) {
                    cell.data('Nie');
                    toastAlert('Pomyślnie wyłączono miejsce polowania');
                } else {
                    cell.data('Tak');
                    toastAlert('Pomyślnie włączono miejsce polowania');
                }
            }
        } catch (err) {
            console.log(err);
        }
    })

    body.on("click", ".btnDeleteDevice", async function (e) {
        e.preventDefault();

        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć te urządzenie?', {color: 'danger'});
        if (!confirm) {
            return;
        }

        let row = $(this).closest('tr');
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }

        let id = row.data('id');
        let spinner = new Spinner();

        let feature = devicesSource.getFeatureById(`device-${id}`);
        if (feature) {
            devicesSource.removeFeature(feature);
        }

        try {
            let response = await axios.post(url(in_app() ? `api/devices/${id}/delete` : `api/admin/devices/${id}/delete`));
            spinner.destroy();

            if (response.data.status === 200) {
                devicesTableApi.rows(row).remove().draw();
                let feature = devicesSource.getFeatureById(`device-${id}`);
                if (feature) {
                    devicesSource.removeFeature(feature);
                }

                toastAlert('Pomyślnie usunięto urządzenie');
            }
        } catch (err) {
        }
    })

    body.on("click", ".btnEditSector", async function (e) {
        e.preventDefault();

        let row = $(this).closest('tr');
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }

        let modalDOM = document.getElementById("editSectorModal");
        let id = row.data('id');
        let form = $("#editSector");
        form.attr('action', url(in_app() ? `api/sectors/${id}/edit` : `api/admin/sectors/${id}/edit`));

        let modalInstance = bootstrap.Modal.getInstance(modalDOM);
        if (!modalInstance) {
            modalInstance = new bootstrap.Modal(modalDOM);
        }
        modalInstance.show();

        let spinner = new Spinner();
        try {
            let response = await axios.get(url(in_app() ? `api/sectors/${id}` : `api/admin/sectors/${id}`));
            spinner.destroy();

            if (response.data.status === 200) {
                let sector = response.data.sector;
                fillFormInputs(form, sector);
            }
        } catch (err) {
            toastAlert('Wystąpił błąd podczas edycji obwodu łowieckiego', {type: 'danger'})
        }
    })

    body.on("click", ".btnEditDevice", async function (e) {
        e.preventDefault();

        let row = $(this).closest('tr');
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }

        let modalDOM = document.getElementById("editDeviceModal");
        let id = row.data('id');
        let form = $("#editDevice");
        form.attr('action', url(in_app() ? `api/devices/${id}/edit` : `api/admin/devices/${id}/edit`));

        let modalInstance = bootstrap.Modal.getInstance(modalDOM);
        if (!modalInstance) {
            modalInstance = new bootstrap.Modal(modalDOM);
        }
        modalInstance.show();

        let spinner = new Spinner();
        try {
            let response = await axios.get(url(in_app() ? `api/devices/${id}` : `api/admin/devices/${id}`));
            spinner.destroy();

            if (response.data.status === 200) {
                let device = response.data.device;
                let coordinates;
                fillFormInputs(form, device);
                if (devicesSource.getFeatureById('device-' + device.id)) {
                    coordinates = toLonLat(devicesSource.getFeatureById('device-' + device.id).getGeometry().getCoordinates());
                }
                if (coordinates) {
                    form.find('#editDevice_latitude').val(coordinates[1]);
                    form.find('#editDevice_longitude').val(coordinates[0]);

                }

            }
        } catch (err) {
            toastAlert('Wystąpił błąd podczas edycji urządzenia', {type: 'danger'})
        }
    })

    let unsavedChanges = false;
    let setUnsavedChanges = state => {
        unsavedChanges = state;
        $("#saveMapChanges").attr('disabled', !unsavedChanges);
    }

    let chosenSector = null;
    body.on("click", ".btnEditCoordinates", async function (e) {
        e.preventDefault();

        let row = $(this).closest('tr');
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }

        let id = row.data('id');
        let multipolygon = parseInt(row.data('is_multipolygon'));
        if (multipolygon !== 1) {
            chooseSector(id);
        }
    })

    let chooseSector = (id) => {
        let chosen = chosenSector;
        deselectSectors();
        if (zonesSource.getFeatures().length > 0) {
            deselectZones();
        }

        if (chosen !== id) {
            let row = sectorsTable.DataTable().$(`tr[data-id="${id}"]`);

            row.find('.btnEditCoordinates').addClass('btn-warning');
            row.next('tr.child').find('.btnEditCoordinates').addClass('btn-warning');

            let rowIndex = sectorsTableApi.row(row).index();
            let actionCell = sectorsTableApi.cell(rowIndex, SECTOR_ACTION_INDEX).node();
            $(actionCell).find('.btnEditCoordinates').addClass('btn-warning');
            row.addClass('bg-info-mild');

            if (actionCell) {
                sectorsTableApi.cell(rowIndex, SECTOR_ACTION_INDEX).data(actionCell[0]);
                sectorsTableApi.rows().invalidate();
            }

            chosenSector = id;
            startDrawingSector(id);
            $("#btnSetDistrictBoundaries").attr('disabled', true);
        } else {
            chosenSector = null;
        }
    }

    let deselectSectors = () => {
        let row = sectorsTable.DataTable().$(`tr.bg-info-mild`);
        let rowIndex = sectorsTableApi.row(row).index();

        row.removeClass('bg-info-mild');
        let actionCell = sectorsTableApi.cell(rowIndex, SECTOR_ACTION_INDEX).node();
        $(actionCell).find('.btnEditCoordinates').removeClass('btn-warning');
        sectorsTable.find('.btnEditCoordinates').removeClass('btn-warning');

        if (actionCell) {
            sectorsTableApi.cell(rowIndex, SECTOR_ACTION_INDEX).data(actionCell[0]);
            sectorsTableApi.rows().invalidate();
        }

        chosenSector = null;
        select.getFeatures().clear();

        map.removeInteraction(drawSector);
        map.removeInteraction(editSector);
        map.removeInteraction(snap);
        $("#btnSetDistrictBoundaries").attr('disabled', false);
    }

    let chosenZone = null;
    body.on("click", ".btnEditZoneCoordinates", async function (e) {
        e.preventDefault();

        let row = $(this.closest('tr'));
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }
        let id = row.data('id');

        let multipolygon = parseInt(row.data('is_multipolygon'));
        if (multipolygon !== 1) {
            chooseZone(id);
        }

    });

    let chooseZone = (id) => {
        let chosen = chosenZone;
        deselectZones();
        deselectSectors();
        deselectDevices();

        if (chosen !== id) {
            let row = zonesTable.DataTable().$(`tr[data-id="${id}"]`);

            row.find('.btnEditZoneCoordinates').addClass('btn-warning');
            row.next('tr.child').find('.btnEditZoneCoordinates').addClass('btn-warning');

            let rowIndex = zonesTableApi.row(row).index();
            let actionCell = zonesTableApi.cell(rowIndex, ZONE_ACTION_INDEX).node();
            $(actionCell).find('.btnEditZoneCoordinates').addClass('btn-warning');
            row.addClass('bg-info-mild');

            if (actionCell) {
                zonesTableApi.cell(rowIndex, ZONE_ACTION_INDEX).data(actionCell[0]);
                zonesTableApi.cell(rowIndex, ZONE_ACTION_INDEX).data(actionCell[0]);
                zonesTableApi.rows().invalidate();
            }

            chosenZone = id;
            startDrawingZone(id);
            $("#btnSetDistrictBoundaries").attr('disabled', true);
        } else {
            chosenZone = null;
        }
    }


    let deselectZones = () => {
        let row = zonesTable.DataTable().$(`tr.bg-info-mild`);
        let rowIndex = zonesTableApi.row(row).index();

        row.removeClass('bg-info-mild');
        let actionCell = zonesTableApi.cell(rowIndex, ZONE_ACTION_INDEX).node();
        $(actionCell).find('.btnEditZoneCoordinates').removeClass('btn-warning');
        zonesTable.find('.btnEditZoneCoordinates').removeClass('btn-warning');

        if (actionCell) {
            zonesTableApi.cell(rowIndex, ZONE_ACTION_INDEX).data(actionCell[0]);
            zonesTableApi.rows().invalidate();
        }

        chosenZone = null;
        select.getFeatures().clear();

        map.removeInteraction(drawZone);
        map.removeInteraction(editZone);
        map.removeInteraction(zonesSnap);
        map.removeInteraction(snap);
        $("#btnSetDistrictBoundaries").attr('disabled', false);

    }


    let epMap = new EpMap({
        withBoundariesLayer: true,
        updateSizeAfterInit: true,
        ruler: true
    });
    let map = epMap.getOlMap();
    let view = epMap.getView();
    let boundariesSource = epMap.boundaries.getSource();

    let sectorsLayer = epMap.addSectorsLayer().getLayer();
    let sectorsSource = epMap.sectors.getSource();

    let devicesLayer = epMap.addDevicesLayer().getLayer();
    let devicesSource = epMap.devices.getSource();

    if (typeof window._inventory_zones != 'undefined') {
        let inventory_zones = JSON.parse(window._inventory_zones);
        let inventoryZonesEpLayer = epMap.addInventoryZonesLayer();

        inventoryZonesEpLayer.addInventoryZonesFromObject(inventory_zones);
    }

    epMap.addZonesLayer().getLayer();
    let zonesLayer = epMap.addZonesLayer().getLayer();
    let zonesSource = epMap.zones.getSource();

    epMap.hideLabelsIfNecessary();

    let snap = epMap.addSnap(sectorsSource);
    let zonesSnap = epMap.addSnap(zonesSource);

    let drawSector = epMap.sectors.addDraw({
        style: drawSectorsStyle,
        end: function (e) {
            e.feature.setId(chosenSector);
            e.feature.set('name', sectorsTable.DataTable().$(`tr[data-id="${chosenSector}"]`).find('.sector__name').text());
            e.feature.set('changed', true);

            deselectSectors();
            setTimeout(() => epMap.canSelect = true, 500);
            setUnsavedChanges(true);
        }
    })

    let drawZone = epMap.zones.addDraw({
        style: drawZonesStyle,
        end: function (e) {
            e.feature.setId(chosenZone);
            e.feature.set('name', zonesTable.DataTable().$(`tr[data-id="${chosenZone}"]`).find('.zone__name').text());
            e.feature.set('changed', true);
            let type_id = zonesTable.DataTable().$(`tr[data-id="${chosenZone}"]`).find('.zone__type').data('type');

            e.feature.set('type', type_id);

            deselectZones();
            setTimeout(() => epMap.canSelect = true, 500);
            setUnsavedChanges(true);
        }
    })

    let drawBoundaries = epMap.boundaries.addDraw({
        end: function (e) {
            e.feature.setId('boundaries');
            snap.addFeature(e.feature);

            map.removeInteraction(drawBoundaries);
            map.removeInteraction(snap);
            setUnsavedChanges(true);

            $("#btnSetDistrictBoundaries").trigger('click');

            try {
                let feature = e.features.item(0);
                if (feature) {
                    let coordinates = feature.getGeometry().getCoordinates().map(arr => arr.map(el => toLonLat(el).join(',')).join(' '))[0];
                    $("textarea#coordinates").val(coordinates);
                }
            } catch (err) {
            }
        }
    });
    let editSector, editBoundaries, editZone;
    let select = epMap.addSelect([sectorsLayer, devicesLayer, zonesLayer]);

    map.addInteraction(select);
    select.on('select', function (e) {
        if (e.selected.length === 0) {
            deselectSectors();
            deselectDevices();
            if (zonesSource.getFeatures().length > 0) {
                deselectZones();
            }

            return;
        }

        let featureId = e.selected[0].getId();
        if (sectorsSource.getFeatureById(featureId)) {
            deselectDevices();
            if (zonesSource.getFeatures().length > 0) {
                deselectZones();
            }
            if (featureId !== chosenSector) {
                if (e.selected[0].values_.geometry.getType() !== "MultiPolygon") {
                    chooseSector(featureId);
                } else {
                    deselectSectors();
                }
                return;
            }
        }

        if (devicesSource.getFeatureById(featureId)) {
            deselectSectors();
            deselectZones();
            featureId = featureId.split('-')[1];
            if (featureId !== currentDevice) {
                selectDevice(featureId);
            }
        }

        if (zonesSource.getFeatureById(featureId)) {
            deselectSectors();
            deselectDevices();
            if (featureId !== chosenZone) {
                if (e.selected[0].values_.geometry.getType() !== "MultiPolygon") {
                    chooseZone(featureId);
                } else {
                    deselectZones();
                }
                return;
            }
        }
    })

    let startDrawingSector = (id) => {
        let feature = sectorsSource.getFeatureById(id);

        if (!feature) {
            epMap.canSelect = false;
            map.addInteraction(drawSector);
        } else {
            editSector = epMap.sectors.addEdit({
                style: drawSectorsStyle,
                features: new Collection([feature]),
                end: function (e) {
                    let feature = e.features.item(0);
                    if (feature) {
                        feature.set('changed', true);
                        setUnsavedChanges(true);
                    }
                }
            });


            select.getFeatures().push(feature);
            map.addInteraction(editSector);
        }

        map.addInteraction(snap);
    }

    let startDrawingZone = (id) => {
        let feature = zonesSource.getFeatureById(id);

        if (!feature) {
            epMap.canSelect = false;

            map.addInteraction(drawZone);


        } else {
            editZone = epMap.zones.addEdit({
                style: drawZonesStyle,
                features: new Collection([feature]),
                end: function (e) {
                    let feature = e.features.item(0);
                    if (feature) {
                        feature.set('changed', true);
                        setUnsavedChanges(true);
                    }
                }
            });

            select.getFeatures().push(feature);
            map.addInteraction(editZone);
        }

        map.addInteraction(zonesSnap);
        map.addInteraction(snap);
    }

    // var draw;
    //
    // function addInteractions() {
    //     draw = new ol.interaction.Draw({
    //         source: vectorSource,
    //         type: "Polygon",
    //     });
    //     map.addInteraction(draw);
    //
    //     draw.on("drawend", function (event) {
    //         // Get the drawn polygon geometry
    //         var polygonGeometry = event.feature.getGeometry();
    //
    //         // Iterate through features and check if they are inside the polygon
    //         vectorSource.forEachFeature(function (feature) {
    //             var pointGeometry = feature.getGeometry();
    //             if (polygonGeometry.intersectsCoordinate(pointGeometry.getCoordinates())) {
    //                 // The point is inside the polygon, you can handle it here
    //                 console.log("Point inside polygon:", pointGeometry.getCoordinates());
    //             }
    //         });
    //     });
    // }
    //
    // // Add interactions when the map is clicked
    // map.on("click", function (event) {
    //     addInteractions();
    // });


    $("#saveMapChanges").click(async function () {
        let spinner = new Spinner();
        let features = sectorsSource.getFeatures();
        let devices = devicesSource.getFeatures();
        let zones = zonesSource.getFeatures();

        try {
            let boundaries = boundariesSource.getFeatureById('boundaries');
            let coordinates = '';

            if (boundaries && !boundaries.getGeometry().getCoordinates().includes(NaN)) {
                coordinates = boundaries.getGeometry().getCoordinates()[0].map((coords) => toLonLat(coords));
            }

            if (boundaries) {
                await axios.post($(this).data('boundaries_url'), {
                    boundaries: coordinates
                });
            }

            await axios.post($(this).data('sectors_url'), {
                sectors: features.map((feature) => {
                    return {
                        id: feature.getId(),
                        geometry: feature.getGeometry().getCoordinates()[0].map((coords) => toLonLat(coords)),
                        changed: feature.get('changed') || false
                    }
                }),
            });

            for (let feature of features) {
                feature.set('changed', false);
            }

            await axios.post($(this).data('devices_url'), {
                devices: devices.map((feature) => {
                    return {
                        id: feature.getId(),
                        geometry: toLonLat(feature.getGeometry().getCoordinates()),
                        changed: feature.get('changed') || false
                    }
                }),
            });

            for (let feature of features) {
                feature.set('changed', false);
            }

            for (let device of devices) {
                device.set('changed', false);
            }

            await axios.post($(this).data('zones_url'), {
                zones: zones.map((feature) => {
                    return {
                        id: feature.getId(),
                        geometry: feature.getGeometry().getCoordinates()[0].map((coords) => toLonLat(coords)),
                        changed: feature.get('changed') || false
                    }
                }),
            });

            for (let zone of zones) {
                zone.set('changed', false);
            }

            spinner.destroy();
            toastAlert('Pomyślnie zapisano zmiany na mapie.');
            setUnsavedChanges(false);

        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby zapisu mapy. Spróbuj ponownie później.', {type: 'danger'});
            spinner.destroy();
        }
    })



    function updateBoundariesOnMap() {
        let feature = boundariesSource.getFeatureById('boundaries');
        if (feature) {
            boundariesSource.removeFeature(feature);
        }

        feature = createFeatureFromCoordinates(mapContainer.data('coordinates'), 'boundaries');
        feature.setId('boundaries');
        boundariesSource.addFeature(feature);
        snap.addFeature(feature);

        try {
            view.fit(boundariesSource.getExtent(), {padding: [24, 24, 24, 24]});
        } catch (err) {
        }
    }

    // Boundary feature
    if (mapContainer.data('coordinates').length > 0) {
        updateBoundariesOnMap();
    }

    $("#coordinatesApply").click(function () {
        mapContainer.data('coordinates', $("textarea#coordinates").val());
        updateBoundariesOnMap();

        setUnsavedChanges(true);

        closeModal('#coordinatesModal')
    })

    try {

        sectorsTable.DataTable().$("tr[data-coordinates]").each(function () {
            let coordinates = $(this).data('coordinates');
            if (coordinates === '') {
                return;
            }

            epMap.sectors.addToMapFromCoordinates(coordinates, {
                id: $(this).data('id'),
                name: $(this).find('.sector__name').text(),
                description: $(this).find('.sector__name').data('description') ?? '',
            });
        })
    } catch (e) {
        toastAlert('Wystąpił problem z odczytem geometrii niektórych sektorów.', {type: 'danger'});
    }

    try {
        zonesTable.DataTable().$("tr[data-coordinates]").each(function () {
            let coordinates = $(this).data('coordinates');
            if (coordinates === '') {
                return;
            }

            epMap.zones.addToMapFromCoordinates(coordinates, {
                id: $(this).data('id'),
                name: $(this).find('.zone__name').text(),
                type: $(this).find('.zone__type').data('type')
            });
        })
    } catch (e) {
        toastAlert('Wystąpił problem z odczytem geometrii niektórych ograniczeń.', {type: 'danger'});
    }

    window.addEventListener("beforeunload", function (e) {
        if (unsavedChanges) {
            let confirmationMessage = 'Jesteś pewny/a, że chcesz wyjść? Niezapisane zmiany zostaną usunięte..';
            e.returnValue = confirmationMessage; //Gecko + IE
            return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
        }
    });

    let updateBoundariesModifyingState = () => {
        let button = $('#btnSetDistrictBoundaries');

        let state = button.attr('data-modifying');
        if (typeof state == 'undefined') {
            state = false;
        } else if (state === "false") {
            state = false;
        } else if (state === "true") {
            state = true;
        }
        button.attr('data-modifying', !state);

        return state;
    }

    $("#btnSetDistrictBoundaries").click(function () {
        let state = updateBoundariesModifyingState();

        if (!state) {
            $(this).removeClass('btn-primary');
            $(this).addClass('btn-warning');

            epMap.canSelect = false;
            let feature = boundariesSource.getFeatureById('boundaries');
            if (!feature) {
                map.addInteraction(drawBoundaries);
            } else {
                editBoundaries = epMap.boundaries.addEdit({
                    features: new Collection([feature]),
                    end: function (e) {
                        setUnsavedChanges(true);

                        try {
                            let feature = e.features.item(0);
                            if (feature) {
                                let coordinates = feature.getGeometry().getCoordinates().map(arr => arr.map(el => toLonLat(el).join(',')).join(' '))[0];
                                $("textarea#coordinates").val(coordinates);
                            }
                        } catch (err) {
                        }
                    }
                });
                map.addInteraction(editBoundaries);
            }
            $('.btnEditCoordinates').attr('disabled', true);
            $('.btnEditDeviceCoordinates').attr('disabled', true);
            map.addInteraction(snap);
        } else {
            $(this).removeClass('btn-warning');
            $(this).addClass('btn-primary');

            map.removeInteraction(editBoundaries);
            map.removeInteraction(drawBoundaries);
            map.removeInteraction(snap);

            $('.btnEditCoordinates').attr('disabled', false);
            $('.btnEditDeviceCoordinates').attr('disabled', false);
            setTimeout(() => epMap.canSelect = true, 500);
        }
    })

    // DEVICES
    let drawDevice = epMap.devices.addDraw({
        type: 'Point',
        style: undefined,
        end: function (e) {
            e.feature.setId(`device-${currentDevice}`);
            e.feature.set('name', devicesTable.DataTable().$(`tr[data-id="${currentDevice}"]`).find('.device__name').text());
            e.feature.set('changed', true);
            e.feature.set('type', 'device');
            e.feature.set('device_type_id', devicesTable.DataTable().$(`tr[data-id="${currentDevice}"]`).find('.device__type').data('id'));

            setTimeout(() => {
                epMap.canSelect = true;
            }, 1000);

            deselectDevices();
            setUnsavedChanges(true);
        }
    })
    let editDevice;

    let currentDevice = null;
    let deselectDevices = () => {
        let row = devicesTable.DataTable().$(`tr[data-id]`);
        let buttons = row.find('.btnEditDeviceCoordinates');

        row.removeClass('bg-info-mild');
        buttons.removeClass('btn-warning');
        buttons.addClass('btn-primary');

        currentDevice = null;
        select.getFeatures().clear();
        $("#btnSetDistrictBoundaries").attr('disabled', false);

        map.removeInteraction(drawDevice);
        map.removeInteraction(editDevice);
    }

    let selectDevice = (id) => {
        id = parseInt(id);

        let oldCurrent = currentDevice;
        deselectDevices();

        if (oldCurrent === id) {
            return;
        }

        currentDevice = id;
        let row = devicesTable.DataTable().$(`tr[data-id="${id}"]`);
        let button = row.find('.btnEditDeviceCoordinates');
        $("#btnSetDistrictBoundaries").attr('disabled', true);

        row.addClass('bg-info-mild');
        button.removeClass('btn-primary');
        button.addClass('btn-warning');

        let feature = devicesSource.getFeatureById(`device-${id}`);
        if (!feature) {
            epMap.canSelect = false;
            map.addInteraction(drawDevice);
        } else {
            editDevice = epMap.devices.addEdit({
                features: new Collection([feature]),
                end: function (e) {
                    let feature = e.features.item(0);
                    if (feature) {
                        feature.set('changed', true);
                        setUnsavedChanges(true);
                    }
                }
            });

            map.addInteraction(editDevice);
            select.getFeatures().push(feature);
        }
    }

    body.on("click", ".btnEditDeviceCoordinates", function () {
        let row = $(this).closest('tr');
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }

        row.removeClass('deviceNoCoords');
        let id = row.data('id');
        selectDevice(id);
    })

    devicesTable.DataTable().$("tr[data-coordinates]").each(function () {
        let coordinates = $(this).data('coordinates');
        if (coordinates === '') {
            return;
        }

        let row = $(this).closest('tr');
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }

        epMap.devices.addToMapFromCoordinates(coordinates, {
            id: $(this).data('id'),
            name: row.find('.device__name').text(),
            device_type_id: row.find('.device__type').data('id')
        });
    })

    // Shutdowns
    let shutdowns = [];

    body.on("click", ".btnSectorShutdowns", async function (e) {
        e.preventDefault();

        let modalDOM = document.getElementById("sectorShutdownsModal");

        let row = $(this).closest('tr');
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }

        let id = row.data('id');
        let form = $("#addSectorShutdown");
        form.attr('action', url(in_app() ? `api/sectors/${id}/shutdowns/add` : `api/admin/sectors/${id}/shutdowns/add`));

        let tbody = $("#sectorShutdownsModal").find('table tbody');
        tbody.empty();

        let modalInstance = bootstrap.Modal.getInstance(modalDOM);
        if (!modalInstance) {
            modalInstance = new bootstrap.Modal(modalDOM);
        }
        modalInstance.show();

        let spinner = new Spinner();
        try {
            let response = await axios.get(url(in_app() ? `api/sectors/${id}/shutdowns` : `api/admin/sectors/${id}/shutdowns`));
            spinner.destroy();

            if (response.data.status === 200) {
                shutdowns = response.data.shutdowns;
                for (let shutdown of shutdowns) {
                    let row = $(`<tr data-id="${shutdown.id}"></tr>`);
                    tbody.append(row);

                    row.append(`<td>${shutdown.start} - ${shutdown.end}</td>`);
                    row.append(`<td>${shutdown.reason || '-'}</td>`);
                    row.append(`
                        <td>
                            <button class="btn btn-sm btn-danger btnDeleteSectorShutdown">
                                <i class="fas fa-trash me-2"></i>
                                Usuń
                            </button>
                        </td>
                    `);
                }
            }
        } catch (err) {
        }
    })

    handleApiForm("#addSectorShutdown", function ({response}) {
        let modalInstance = bootstrap.Modal.getInstance(document.getElementById("addSectorShutdownModal"));
        modalInstance.hide();

        let shutdown = response.data.shutdown;
        let tbody = $("#sectorShutdownsModal").find('table tbody');
        let row = $(`<tr data-id="${shutdown.id}"></tr>`);
        tbody.append(row);

        shutdowns.push(shutdown);
        checkShutdowns(shutdown.sector_id);

        row.append(`<td>${shutdown.start} - ${shutdown.end}</td>`);
        row.append(`<td>${shutdown.reason || '-'}</td>`);
        row.append(`
            <td>
                <button class="btn btn-sm btn-danger btnDeleteSectorShutdown">
                    <i class="fas fa-trash me-2"></i>
                    Usuń
                </button>
            </td>
        `);

        toastAlert('Pomyślnie dodano zamknięcie');
    })

    body.on("click", ".btnDeleteSectorShutdown", async function () {
        let row = $(this).closest('tr');
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }

        let id = row.data('id');

        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć te zamknięcie?', {color: 'danger'});
        if (!confirm) {
            return;
        }

        let spinner = new Spinner();
        try {
            let response = await axios.post(url(in_app() ? `api/sectors/shutdowns/${id}/delete` : `api/admin/sectors/shutdowns/${id}/delete`));
            spinner.destroy();

            if (response.data.status === 200) {

                let index = shutdowns.findIndex(s => parseInt(s.id) === parseInt(id));
                if (index !== -1) {
                    let sector_id = shutdowns[index].sector_id;
                    shutdowns.splice(index, 1);
                    checkShutdowns(sector_id);
                }

                $(this).closest('tr').remove();
                toastAlert('Pomyślnie usunięto zamknięcie miejsca polowań');
            }
        } catch (err) {
        }
    });

    const checkShutdowns = (id) => {
        let is_closed = false;
        for (let shutdown of shutdowns) {
            if (moment(shutdown.start).isSameOrBefore(moment(), 'day') && moment(shutdown.end).isSameOrAfter(moment(), 'day')) {
                is_closed = true;
                break;
            }
        }

        let row = sectorsTable.DataTable.$(`tr[data-id=${id}]`);
        let rowIndex = sectorsTableApi.row(row).index();
        let cell = sectorsTableApi.cell(rowIndex, SECTOR_ACTIVE_INDEX);

        if (is_closed) {
            cell.data('Nie');

            row.find('.sector__is_active').text('Nie');
            row.next('tr.child').find('.sector__is_active').text('Nie');
        } else {
            cell.data('Tak');

            row.find('.sector__is_active').text('Tak');
            row.next('tr.child').find('.sector__is_active').text('Tak');
        }
    }

    body.on("click", ".btnDeleteSector", async function () {
        let row = $(this).closest('tr');
        if (row.hasClass('child')) {
            row = row.prev('tr');
        }

        let id = row.data('id');

        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć te miejsce polowań?', {color: 'danger'});
        if (!confirm) {
            return;
        }

        let spinner = new Spinner();
        try {
            let response = await axios.post(url(in_app() ? `api/sectors/${id}/delete` : `api/admin/sectors/${id}/delete`));
            spinner.destroy();

            if (response.data.status === 200) {
                sectorsTableApi.row(row).remove().draw();
                toastAlert('Pomyślnie usunięto miejsce polowań');

                let feature = sectorsSource.getFeatureById(id);
                sectorsSource.removeFeature(feature);
            }
        } catch (err) {
        }
    });

    zonesTable.$('.dataTip').each(function () {
        new bootstrap.Tooltip(this)
    });

    // import boundaries
    const importBoundariesModal = $('#importBoundariesModal');

    if (importBoundariesModal.length) {
        const field = importBoundariesModal.find('[name="field"]')
        const form = importBoundariesModal.find('form')

        importBoundariesModal[0].addEventListener('show.bs.modal', function() {
            field.empty();
            hideField(form, 'field')

            window.fileLists['files[]'] = [];
            renderList(form.find('[name="files[]"]'))
            importBoundariesModal.find('[data-app-file_container]').show();
        })

        let importFeatures = [];

        $('#btnImportShpSubmit').click(async function () {
            if(field.val() && field.val().length) {
                const index = parseInt(field.val());
                const feature = importFeatures[index] ?? null;

                if(feature) {
                    let coordinates = feature.getGeometry().getCoordinates().map(arr => arr.map(el => toLonLat(el).join(',')).join(' '))[0];
                    $("textarea#coordinates").val(coordinates);

                    let f = boundariesSource.getFeatureById('boundaries');
                    if (f) {
                        boundariesSource.removeFeature(f);
                    }

                    feature.setId('boundaries');
                    boundariesSource.addFeature(feature);
                    snap.addFeature(feature);

                    try {
                        view.fit(boundariesSource.getExtent(), {padding: [24, 24, 24, 24]});
                    } catch (err) {
                    }

                    setUnsavedChanges(true);

                    toastAlert('Pomyślnie zaimportowano granice obwodu. Kliknij przycisk "Zapisz zmiany na mapie" aby zapisać zmiany.')
                    closeModal(importBoundariesModal)
                }

                return;
            }

            importFeatures = await handleShpForm($(this).closest('form'))
            if (importFeatures.length) {
                for(const index in importFeatures) {
                    const potentialNames = ['F_R_NAME', 'NZW_NADL', 'ADR_LES', 'ADR_FOR'];
                    let name = 'Brak nazwy';
                    for(let prop of potentialNames) {
                        if(importFeatures[index].get(prop)) {
                            name = importFeatures[index].get(prop);
                            break;
                        }
                    }

                    field.append(`<option value="${index}">${name}</option>`)
                }

                showField(form, 'field')
                importBoundariesModal.find('[data-app-file_container]').hide();
            }
        })
    }
}
